/**
 *
 * @prettier
 * @author Alexander Clary
 * @author Russell Lilljedahl
 */
import { catchCommonErrors } from 'app/actions/commonActionUtils'
import { SubmissionError } from 'redux-form'
import { convertLgyErrorResponseToFormErrorObject } from 'app/utils/formUtils'
import {
  genericThunkCreator2,
  genericFetchingActionCreator,
  genericPostingActionCreator,
  getCookieValue
} from 'app/actions/genericActionCreator'

export const getJobs = () => genericThunkCreator2('JOBS', `/lgyhub/api/jobs`)

export const getJob = jobName => (dispatch, getState) => {
  const state = getState()
  dispatch(genericFetchingActionCreator('JOB', 'fetching', { jobName: jobName }))
  fetch(`/lgyhub/api/jobs/${jobName}`, {
    credentials: 'include',
    method: 'GET'
  })
    .then(response => {
      return catchCommonErrors(dispatch, response, `fetching ${jobName}`)
    })
    .then(responseJson => {
      let jobs = state.jobState.jobs
      let jobToReplace = jobs.findIndex(job => job.name === responseJson.name)
      jobs[jobToReplace] = responseJson
      dispatch(genericFetchingActionCreator('JOB', 'fetched', { jobName: jobName, jobs: jobs }))
    })
    .catch(error => {
      dispatch(genericFetchingActionCreator('JOB', 'error'))
      console.error('There has been a problem fetching jobs: ', error)
    })
}

export const startJob = jobName =>
  genericThunkCreator2('JOBS', `/lgyhub/api/jobs/${jobName}/runs?force=true`, { method: 'POST' })

/**
 * Simple update. Passes values from the form for the backend to process
 *
 * @param {Object} formValues Any values passed from form
 * @callback props.fetched Function to callback when fetched. Callback receives
 *  dispatch and responseJson
 */
export const updateJob = formValues => async dispatch => {
  dispatch(genericPostingActionCreator('JOB', 'posting'))
  try {
    const response = await fetch(`/lgyhub/api/jobs/${formValues.name}`, {
      credentials: 'include',
      method: 'PATCH',
      body: JSON.stringify(formValues),
      headers: new Headers({
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      })
    })
    const responseJson = await catchCommonErrors(dispatch, response, `updating job: ${formValues.name}`)
    if (responseJson.status >= 400 || response.status >= 400) {
      dispatch(genericPostingActionCreator('JOB', 'error', responseJson))
      console.error(`Error sending form data: ${`/lgyhub/api/jobs/${formValues.name}`}`)
      throw new SubmissionError(convertLgyErrorResponseToFormErrorObject(responseJson))
    } else {
      dispatch(genericPostingActionCreator('JOB', 'posted', responseJson))
      dispatch(getJob(formValues.name))
    }
  } catch (e) {
    if (e instanceof SubmissionError) {
      throw e
    }
    console.error(e)
  }
}
